import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSPersonalInfoData, type EnrollmentHYCSPersonalInfoSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSPersonalInfoDataMock: EnrollmentHYCSPersonalInfoData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/personal-info',
}

export const submitEnrollmentHYCSPersonalInfoDataMock: EnrollmentHYCSPersonalInfoSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/secure-account',
}

export const mockGetEnrollmentHYCSPersonalInfoData = graphql.mutation('getEnrollmentHYCSPersonalInfoData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSPersonalInfoDataMock } })
})

export const mockSubmitEnrollmentHYCSPersonalInfoData = graphql.mutation('submitEnrollmentHYCSPersonalInfoData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSPersonalInfoDataMock } })
})

export const mockEnrollmentHYCSPersonalInfo = [
  mockGetEnrollmentHYCSPersonalInfoData,
  mockSubmitEnrollmentHYCSPersonalInfoData,
]
